import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { COLORS, SIZES, WEIGHT } from "theme";
import { HOST } from "api/apiClient";
import H2 from "ReusableComponents/Text/H2";

const DriverNotification = ({ small, notifications }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      marginTop="154px"
      paddingTop="80px"
      flexDirection="column"
      w={small ? "100%" : "918px"}
      margin="0 auto"
      textAlign="center"
      padding={small && "20px"}
    >
      <Box>
        <H2
          fontSize={small ? SIZES.twenty : SIZES.forty}
          fontWeight={WEIGHT.bold}
          textColor={COLORS.white}
          margin={SIZES.zero}
        >
          {notifications?.attributes?.title}
        </H2>
      </Box>
      <Box
        marginTop={small ? SIZES.twenty : SIZES.forty}
        display="flex"
        flexDirection="column"
      >
        <Text
          fontSize={small ? SIZES.fourteen : SIZES.twenty}
          fontWeight={WEIGHT.regular}
          textColor={COLORS.lightGrey}
          margin={SIZES.zero}
          lineHeight="2"
        >
          {notifications?.attributes?.description}
        </Text>

        <Box
          h={small ? "auto" : "500px"}
          marginBottom={small ? SIZES.forty : SIZES.eighty}
          padding={small && "40px"}
          marginTop={SIZES.twentyFour}
        >
          <img
            src={HOST + notifications?.attributes?.media?.data?.attributes?.url}
            alt={
              notifications?.attributes?.media?.data?.attributes
                ?.alternativeText
            }
            style={{ height: "100%", width: small && "100%" }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DriverNotification;
